import React,{useContext} from 'react'
import {QuestionnaireCodeProvider,QuestionnaireCodeContext} from './QuestionnaireCodeContext';

import { Button } from 'react-bootstrap';


export function KeyEntryDialog(props) {
    return (
        <div className="user-message-wrapper fadeInDown">
            <div className="login-form-content">
                <div  className="pcrb-logo"></div>
                <h2 className="code-login-welcome">
                    Enter Access Code
                </h2>
                <h6 className="code-login-text">Please enter the Access Code that was provided in the PCRB/DCRB correspondence.  
                This code will allow you to access the document specifically created for your organization. 
                    <br/>All code characters are letters (A-Z only)
                </h6>
                <br></br>
                <KeyEntryControl {...props}></KeyEntryControl>
            </div>
        </div>
    )}

    

const renderButton= ({afterCodeConfirmationAction,buttonText}) =>{
    const {key1,key2, openForm,setLoading} = useContext(QuestionnaireCodeContext);
    return (
    <Button onClick={()=> {setLoading(true); afterCodeConfirmationAction()}} disabled={!(key1 && key2)} >
        {renderButtonText(buttonText)}
    </Button>);
}

const renderButtonText=(buttonText)=>{
    
    const {loading} = useContext(QuestionnaireCodeContext);
    if(loading)
        return (
        <span>
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> 
            <span> Loading...</span>
        </span>);
    else
        return(<span>{buttonText}</span>);    
}

export function KeyEntryControl (props) {
    const {key1,setKey1,key2,setKey2,error} = useContext(QuestionnaireCodeContext);
    return(
    <div>        
        <form className="form-inline" style={{"justifyContent":"center"}} >                        
        <input autoFocus value={key1} onChange={evt => setKey1(evt.target.value)} className="form-control code-input-box"  />     
        <span style={{"margin":"8px"}}>-</span>
        <input value={key2} onChange={evt =>  setKey2(evt.target.value)} className="form-control code-input-box"  />                     </form>
        <br></br>
        {error == "401" &&
        <div>
            <div className="code-login-error">The access code that you have entered is either incorrect or expired. Please check code, and try again or contact Central Support at centralsupport@pcrb.com</div>
            <br></br>
        </div>
        }
        {renderButton(props)}
        
    </div>);
}
